import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import states from "./states.json";
import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { callRemote, GET, PUT } from "../service/RemoteService";
import { determineIfTokenError } from "../store/AuthThunks";

export const ProfileComponent = () => {
  let dispatch = useDispatch();
  const { user, getAccessTokenSilently } = useAuth0();
  const [profile, setProfile] = useState(null);
  const [validation, setValidation] = useState({
    street: true,
    firstName: true,
    lastName: true,
    city: true,
    zip: true,
    phoneNumber: true
});

  useEffect(() => {
    const getProfile = async () => {
      try {
        setProfile(await callRemote(getAccessTokenSilently, GET, "/photographers/get"));
      } catch (e) {
        dispatch(determineIfTokenError(e));
      }
    };
    getProfile();
  }, [dispatch, getAccessTokenSilently]);

  const handleInputChange = e => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
    setValidation({ ...validation, [e.target.name]: e.target.value !== '' });
  };

  const submit = async () => {
    if(!validate()) {
      return;
  }
    try {
      await callRemote(getAccessTokenSilently, PUT, "/photographers/update", profile);
    } catch (e) {
      dispatch(determineIfTokenError(e));
    }
  };

  const validate = () => {
    const newValidation = {
      firstName: profile.firstName !== '',
      lastName: profile.lastName !== '',
      street: profile.street !== '',
      city: profile.city !== '',
      zip: /^[0-9]+$/.test(profile.zip) && profile.zip.length === 5,
      phoneNumber: /^[0-9]+$/.test(profile.phoneNumber) && profile.phoneNumber.length === 10
    };
    setValidation(
        newValidation
    )
    return Object.values(newValidation).every(Boolean);
}

  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
        <Col md={2}>
          <img
            src={user.picture}
            alt="Profile"
            className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
          />
        </Col>
        <Col md>
          <h2>{user.name}</h2>
          <p className="lead text-muted">{user.email}</p>
        </Col>
      </Row>
      <Row>
        {profile && (
          <Form>
            <FormGroup>
              <Label for="street">First Name</Label>
              <Input type="text" name="firstName" id="firstName" value={profile.firstName} onChange={handleInputChange} invalid={!validation.firstName}/>
            </FormGroup>
            <FormGroup>
              <Label for="street">Last Name</Label>
              <Input type="text" name="lastName" id="lastName" value={profile.lastName} onChange={handleInputChange} invalid={!validation.lastName}/>
            </FormGroup>
            <FormGroup>
              <Label for="street">Street</Label>
              <Input type="text" name="street" id="street" value={profile.street} onChange={handleInputChange} invalid={!validation.street}/>
            </FormGroup>
            <FormGroup>
              <Label for="city">City</Label>
              <Input type="city" name="city" id="city" value={profile.city} onChange={handleInputChange} invalid={!validation.city}/>
            </FormGroup>
            <FormGroup>
              <Label for="state">State</Label>
              <Input type="select" name="state" id="state" value={profile.state} onChange={handleInputChange}>
                {states.map(item => (
                  <option key={item.abbreviation} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="zip">ZIP</Label>
              <Input type="zip" name="zip" id="zip" value={profile.zip} onChange={handleInputChange} invalid={!validation.zip}/>
            </FormGroup>
            <FormGroup>
              <Label for="phoneNumber">Phone</Label>
              <Input type="text" name="phoneNumber" id="phoneNumber" value={profile.phoneNumber} onChange={handleInputChange} invalid={!validation.phoneNumber}/>
            </FormGroup>
            <Button onClick={submit}>Save</Button>
          </Form>
        )}
      </Row>
    </Container>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
